import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { HTTP_ERROR_TOAST_KEY } from '@/interceptors/http-error.interceptor';
import { AppEnvironmentBanner } from '@/layout/components/app.environment-banner';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, ToastModule, AppEnvironmentBanner],
    template: `
        <app-environment-banner></app-environment-banner>
        <p-toast [key]="httpErrorToastKey" position="top-right"></p-toast>
        <router-outlet></router-outlet>
    `
})
export class AppComponent {
    protected readonly httpErrorToastKey = HTTP_ERROR_TOAST_KEY;
}
